{
  "version": "0.2.8",
  "extensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "sha256": "69216a32c900a4a2640eeb93532c98fe187b80ef11fe38942fe16af83ae1ae44",
  "bytes": 57907,
  "download": "https://gab.ai/browser-extension/gab-ai-browser-extension-preview.zip",
  "channel": "manual-preview",
  "chatOrigin": "https://gab.ai"
}
